<template>
     <button class="btn mr-2 ml-2">{{buttonName}}</button>
</template>


<script>
export default {
    props:["buttonName"]
}
</script>


<style lang="scss" scoped>
    button{
        height: 35px;
        width: auto;
        font-size:14px;
        border: 1px solid #e43523;
        position: relative;
        bottom: 2px;
    }

    button:hover{
        border: 1px solid #e43523;
        background: #e43523;
        color:#fff !important;
    }
</style>